
export const FLASHCARD_LANGUAGES = [
  { name: 'Africano (Afrikaans)', code: 'af' },
  { name: 'Alemão', code: 'de' },
  { name: 'Árabe', code: 'ar' },
  { name: 'Arapaho', code: 'arp' },
  { name: 'Tibetano', code: 'bo' },
  { name: 'Bretão', code: 'br' },
  { name: 'Búlgaro', code: 'bg' },
  { name: 'Catalão', code: 'ca' },
  { name: 'Cebuano (Filipinas)', code: 'ceb' },
  { name: 'Chinês', code: 'zh' },
  { name: 'Tcheco', code: 'cs' },
  { name: 'Dinamarquês', code: 'da' },
  { name: 'Inglês', code: 'en' },
  { name: 'Inglês Médio', code: 'enm' },
  { name: 'Esperanto', code: 'eo' },
  { name: 'Espanhol', code: 'es' },
  { name: 'Estoniano', code: 'et' },
  { name: 'Persa', code: 'fa' },
  { name: 'Finlandês', code: 'fi' },
  { name: 'Francês', code: 'fr' },
  { name: 'Frisão', code: 'fy' },
  { name: 'Friulano', code: 'fur' },
  { name: 'Galego', code: 'gl' },
  { name: 'Galês', code: 'cy' },
  { name: 'Gaélico Escocês', code: 'gla' },
  { name: 'Grego', code: 'el' },
  { name: 'Hebraico', code: 'he' },
  { name: 'Holandês', code: 'nl' },
  { name: 'Húngaro', code: 'hu' },
  { name: 'Ilocano (Filipinas)', code: 'ilo' },
  { name: 'Interlíngua', code: 'ia' },
  { name: 'Irlandês', code: 'ga' },
  { name: 'Islandês', code: 'is' },
  { name: 'Italiano', code: 'it' },
  { name: 'Inuktitut', code: 'iu' },
  { name: 'Japonês', code: 'ja' },
  { name: 'Latim', code: 'la' },
  { name: 'Maori', code: 'mi' },
  { name: 'Maia', code: 'myn' },
  { name: 'Náuatle', code: 'nah' },
  { name: 'Napolitano', code: 'nap' },
  { name: 'Norueguês', code: 'no' },
  { name: 'Occitânico', code: 'oc' },
  { name: 'Ojíbua', code: 'oj' },
  { name: 'Polonês', code: 'pl' },
  { name: 'Português', code: 'pt' },
  { name: 'Caló (Cigano)', code: 'rmq' },
  { name: 'Romeno', code: 'ro' },
  { name: 'Russo', code: 'ru' },
  { name: 'Sânscrito', code: 'sa' },
  { name: 'Scots', code: 'sco' },
  { name: 'Esloveno', code: 'sl' },
  { name: 'Sérvio', code: 'sr' },
  { name: 'Sueco', code: 'sv' },
  { name: 'Tagalo', code: 'tl' },
  { name: 'Telugo (Índia)', code: 'te' },
  { name: 'Iídiche', code: 'yi' }
];

export const getLanguageCode = (code: string): string => {
  if (!code) return 'en';
  
  const normalizedInput = code.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  
  const languageAliases: Record<string, string> = {
    'ingles': 'en', 'english': 'en', 'us': 'en', 'en us': 'en', 'en-us': 'en', 'en-gb': 'en',
    'frances': 'fr', 'french': 'fr', 'fr-fr': 'fr',
    'alemao': 'de', 'german': 'de', 'de-de': 'de',
    'espanhol': 'es', 'spanish': 'es', 'es-es': 'es',
    'italiano': 'it', 'italian': 'it', 'it-it': 'it',
    'portugues': 'pt', 'portuguese': 'pt', 'pt-br': 'pt', 'pt-pt': 'pt',
    'holandes': 'nl', 'dutch': 'nl', 'nl-nl': 'nl',
    'japones': 'ja', 'japanese': 'ja', 'ja-jp': 'ja',
    'russo': 'ru', 'russian': 'ru', 'ru-ru': 'ru',
    'chines': 'zh', 'chinese': 'zh', 'zh-cn': 'zh',
    'hungaro': 'hu', 'hungarian': 'hu', 'hu-hu': 'hu'
  };

  return languageAliases[normalizedInput] || normalizedInput.split(/[-_ ]/)[0] || 'en';
};

export const getLanguageName = (code: string, t?: any): string => {
  if (!code) return 'Geral';
  
  const normalizedInput = code.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  
  const languageAliases: Record<string, string> = {
    'ingles': 'en', 'english': 'en', 'us': 'en', 'en us': 'en', 'en-us': 'en', 'en-gb': 'en',
    'frances': 'fr', 'french': 'fr', 'fr-fr': 'fr',
    'alemao': 'de', 'german': 'de', 'de-de': 'de',
    'espanhol': 'es', 'spanish': 'es', 'es-es': 'es',
    'italiano': 'it', 'italian': 'it', 'it-it': 'it',
    'portugues': 'pt', 'portuguese': 'pt', 'pt-br': 'pt', 'pt-pt': 'pt',
    'holandes': 'nl', 'dutch': 'nl', 'nl-nl': 'nl',
    'japones': 'ja', 'japanese': 'ja', 'ja-jp': 'ja',
    'russo': 'ru', 'russian': 'ru', 'ru-ru': 'ru',
    'chines': 'zh', 'chinese': 'zh', 'zh-cn': 'zh',
    'hungaro': 'hu', 'hungarian': 'hu', 'hu-hu': 'hu'
  };

  const mappedCode = getLanguageCode(code);

  const found = FLASHCARD_LANGUAGES.find(l => {
    const normCode = l.code.toLowerCase();
    const normName = l.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normCode === mappedCode || normName === normalizedInput || normCode === normalizedInput;
  });

  if (found) {
    if (t) {
      if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
        try {
          const lang = localStorage.getItem('i18nextLng') || 'pt';
          const displayNames = new Intl.DisplayNames([lang], { type: 'language' });
          const name = displayNames.of(found.code);
          if (name) return name.charAt(0).toUpperCase() + name.slice(1);
        } catch (e) {
          console.error(e);
        }
      }
      
      const translationKey = `languages.${found.code}`;
      const translated = t(translationKey);
      if (translated && translated !== translationKey) return translated;
    }
    return found.name;
  }

  return (code.charAt(0).toUpperCase() + code.slice(1));
};

export const LANG_LABEL_MAP: Record<string, string> = {
  'en-US': 'Inglês',
  'en-GB': 'Inglês',
  'fr-FR': 'Francês',
  'de-DE': 'Alemão',
  'pt-BR': 'Português',
  'it-IT': 'Italiano',
  'es-ES': 'Espanhol',
  'nl-NL': 'Holandês',
  'ja-JP': 'Japonês',
  'ru-RU': 'Russo',
  'zh-CN': 'Chinês',
  'hu-HU': 'Húngaro'
};
